"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateURL = generateURL;
exports.getXHRData = getXHRData;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function getXHRData(apiURL, apiMethod, myCallback) {
  getXHRData.propTypes = {
    apiURL: _propTypes.default.string.isRequired,
    apiMethod: _propTypes.default.string.isRequired
  };
  // eslint-disable-next-line no-undef
  const xhr = new XMLHttpRequest();
  xhr.open(apiMethod, apiURL, true);
  // xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  // xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  // xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
  xhr.onreadystatechange = () => {
    // if (xhr.readyState === 4) {
    if (xhr.readyState === 4 && xhr.status === 200) {
      let response;
      // eslint-disable-next-line prefer-const
      response = JSON.parse(xhr.responseText);
      myCallback(response);
    }
  };
  xhr.send();
}
function generateURL(baseURL, props) {
  generateURL.propTypes = {
    baseURL: _propTypes.default.string.isRequired,
    props: _propTypes.default.object
  };
  let url = baseURL;
  let allProps = '';
  for (const prop in props) {
    if (props) {
      allProps.length === 0 ? allProps = prop + '=' + props[prop] : allProps += '&' + prop + '=' + props[prop];
    }
  }
  url += allProps;
  return url;
}